import {
  getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsKey,
  postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancel,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * 従業員一括登録リクエストの予約キャンセル API を実行するカスタムフック
 *
 * - trigger(id) で一括登録リクエスト ID を指定してキャンセルを実行する
 * - レスポンスは 204 No Content（void）
 * - Container 結線・Toast・確認モーダルは LEA-1966 で対応予定
 *
 * @param threeLetterCode - クライアントコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const useCancelUserBulkCreationRequest = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsKey(threeLetterCode),
    (_, { arg }: { arg: number }) =>
      postApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsIdCancel(threeLetterCode, arg),
    options
  );
};
